import { Link } from "react-router-dom";
import { useTranslationEx } from "../../hooks/useTranslationEx";
export type TCityCardProps = {
  id?: number;
  slug?: string;
  name?: string;
  thumbnail?: string;
};
export const CityCard = ({ id, slug, name, thumbnail }: TCityCardProps) => {
  const { t2 } = useTranslationEx({});
  return (
    <Link to={`/cities/${slug}`}>
      <div className="relative h-[5rem] overflow-hidden rounded-[0.75rem]">
        <img
          src={thumbnail}
          alt={t2(name)}
          className="h-[5rem] w-full rounded-[0.5rem] object-cover sm:w-[8.125rem]"
        />
        <div
          className="absolute bottom-0 h-full w-full content-end p-1 text-white"
          style={{
            background:
              "linear-gradient(rgba(0, 0, 0, 0) 42.05%, rgba(0, 0, 0, 0.6) 100%)",
          }}
        >
          <p className="text-center text-[0.875rem] font-semibold leading-[1.375rem]">
            {t2(name)}
          </p>
        </div>
      </div>
    </Link>
  );
};
